let toggle_button_loading = ($button, delay) => {
    if ($button === null) {
        return;
    }

    if ($button.hasClass('disabled')) {
        return;
    }

    let buttonHtml = window.Smart.utils.disable_button($button);

    setTimeout(function () {
        window.Smart.utils.enable_button($button, buttonHtml);
    }, delay || 2000)
}

export default toggle_button_loading;
